export const category = {
    region: '',
    language: '',
    type: '',
    categories: [],
    get schema() {
        return {
            title: 'Category',
            type: 'object',
            properties: {
                type: {
                    title: 'Type',
                    type: 'string',
                    options: {
                        inputAttributes: {
                            class: 'disabled',
                        },
                    },
                },
                parentId: {
                    title: 'Parent Category',
                    type: 'string',
                    enum: [''].concat(this.categories
                        .filter((f) => f.parentId === '' &&
                        f.region === this.region &&
                        f.language === this.language &&
                        f.type === this.type)
                        .map((c) => c.id)),
                    options: {
                        enum_titles: [''].concat(this.categories
                            .filter((f) => f.parentId === '' &&
                            f.region === this.region &&
                            f.language === this.language &&
                            f.type === this.type)
                            .map((c) => c.title)),
                    },
                },
                description: {
                    title: 'Description',
                    type: 'string',
                    format: 'textarea',
                },
                icon: {
                    title: 'Icon',
                    type: 'string',
                },
            },
        };
    },
};
//# sourceMappingURL=categoryJsonEditorConfig.js.map